import { useQuery, useQueryClient } from '@tanstack/react-query';
import { GET_TYPES_STATS } from '../../../../query/monitor/data/sources/keys';
import { getTypesStats } from '../../../../../services/monitor/data/sources/MonitorDataSourcesService';
import { ChatType } from '../../../../../types/monitor/ChatType';
import { TypesStatsResponse } from '../../../../../models/monitor/data/sources/TypesStatsResponse';

export const useGetTypesStats = (
  projectId: number | null,
  chatType: ChatType | null,
  from: Date | null,
  to: Date | null,
  domain?: string[] | null | undefined,
  monitorPromptIds?: number[],
  filterMonitorTypes?: string[]
) => {
  const queryClient = useQueryClient();
  const queryEnabled = !!projectId && !!chatType && !!from && !!to && domain !== null;

  const fromTimestamp = from?.getTime() ?? null;
  const toTimestamp = to?.getTime() ?? null;

  const {
    data: typesStats,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<TypesStatsResponse>({
    queryKey: [GET_TYPES_STATS, projectId, chatType, fromTimestamp, toTimestamp, domain, monitorPromptIds, filterMonitorTypes],
    queryFn: () => getTypesStats(projectId!, chatType!, from, to, domain, monitorPromptIds, filterMonitorTypes),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  return {
    typesStats: queryEnabled
      ? typesStats ?? {
          types: [],
          total: 0,
        }
      : {
          types: [],
          total: 0,
        },
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refetch,
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: [GET_TYPES_STATS, projectId, chatType, fromTimestamp, toTimestamp, domain, monitorPromptIds, filterMonitorTypes],
        refetchType: 'active',
      }),
  };
};
